module.exports = __webpack_public_path__ + "static/media/uploadMedia.22f08642.svg";